import service from '@/utils/request'; // 活动-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/main/getList [get]

export var getActivityList = function getActivityList(params) {
  return service({
    url: '/activity/main/getList',
    method: 'get',
    params: params
  });
}; // 活动-查询单个活动详情
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/main/detail [post]

export var getActivityDetail = function getActivityDetail(data) {
  return service({
    url: '/activity/main/detail',
    method: 'post',
    data: data
  });
}; // 活动-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/main/create [post]

export var createActivity = function createActivity(data) {
  return service({
    url: '/activity/main/create',
    method: 'post',
    data: data
  });
}; // 活动-下载明细
// @Tags GoodsManage
// @Summary 下载明细
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载明细"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/main/download [post]

export var downloadActivity = function downloadActivity(data) {
  return service({
    url: '/activity/main/download',
    method: 'post',
    data: data
  });
}; // 活动-变更
// @Tags GoodsManage
// @Summary 变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/main/update [post]

export var updateActivity = function updateActivity(data) {
  return service({
    url: '/activity/main/update',
    method: 'post',
    data: data
  });
}; // 活动-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/main/delete [delete]

export var deleteActivity = function deleteActivity(data) {
  return service({
    url: '/activity/main/delete',
    method: 'post',
    data: data
  });
}; // 活动-审核
// @Tags GoodsManage
// @Summary 启用禁用
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "启用禁用"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/main/audit

export var auditActivity = function auditActivity(data) {
  return service({
    url: '/activity/main/audit',
    method: 'post',
    data: data
  });
}; // 活动-启用禁用
// @Tags GoodsManage
// @Summary 启用禁用
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "启用禁用"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/main/open [delete]

export var updateActivityStatus = function updateActivityStatus(data) {
  return service({
    url: '/activity/main/open',
    method: 'post',
    data: data
  });
}; // 活动-分页获取邀新小组列表
// @Tags getActivityInviteGroupList
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/invite/group/getList [get]

export var getActivityInviteGroupList = function getActivityInviteGroupList(params) {
  return service({
    url: '/activity/invite/group/getList',
    method: 'get',
    params: params
  });
}; // 活动-删除邀新小组
// @Tags GoodsManage
// @Summary 删除邀新小组
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除邀新小组"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/invite/group/delete [delete]

export var deleteActivityInviteGroupList = function deleteActivityInviteGroupList(data) {
  return service({
    url: '/activity/invite/group/delete',
    method: 'post',
    data: data
  });
}; // 活动-更新邀新小组
// @Tags GoodsManage
// @Summary 更新邀新小组
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新邀新小组"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/invite/group/update [post]

export var updateActivityInviteGroupList = function updateActivityInviteGroupList(data) {
  return service({
    url: '/activity/invite/group/update',
    method: 'post',
    data: data
  });
}; // 活动-创建邀新小组
// @Tags GoodsManage
// @Summary 创建邀新小组
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "创建邀新小组"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/invite/group/create [post]

export var createActivityInviteGroupList = function createActivityInviteGroupList(data) {
  return service({
    url: '/activity/invite/group/create',
    method: 'post',
    data: data
  });
}; // 活动-分页获取邀新组员列表
// @Tags getActivityInviteGroupUserList
// @Summary 分页获取邀新组员列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取邀新组员列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/invite/group/user/getList [get]

export var getActivityInviteGroupUserList = function getActivityInviteGroupUserList(params) {
  return service({
    url: '/activity/invite/group/user/getList',
    method: 'get',
    params: params
  });
}; // 活动-删除邀新组员
// @Tags GoodsManage
// @Summary 删除邀新组员
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除邀新组员"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/invite/group/user/delete [delete]

export var deleteActivityInviteGroupUserList = function deleteActivityInviteGroupUserList(data) {
  return service({
    url: '/activity/invite/group/user/delete',
    method: 'post',
    data: data
  });
}; // 活动-更新邀新组员
// @Tags updateActivityInviteGroupUserList
// @Summary 更新邀新组员
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新邀新组员"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/invite/group/user/update [post]

export var updateActivityInviteGroupUserList = function updateActivityInviteGroupUserList(data) {
  return service({
    url: '/activity/invite/group/user/update',
    method: 'post',
    data: data
  });
}; // 活动-添加邀新组员
// @Tags createActivityInviteGroupUserList
// @Summary 添加邀新组员
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "添加邀新组员"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/invite/group/user/create [post]

export var createActivityInviteGroupUserList = function createActivityInviteGroupUserList(data) {
  return service({
    url: '/activity/invite/group/user/create',
    method: 'post',
    data: data
  });
}; // 积分用户配置-分页获取列表
// @Tags getPointUserList
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/point/mainUser/getList [get]

export var getPointUserList = function getPointUserList(params) {
  return service({
    url: '/activity/point/mainUser/getList',
    method: 'get',
    params: params
  });
}; // 积分用户配置-添加
// @Tags createPointUser
// @Summary 积分用户
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "添加"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/point/mainUser/create [post]

export var createPointUser = function createPointUser(data) {
  return service({
    url: '/activity/point/mainUser/create',
    method: 'post',
    data: data
  });
}; // 积分用户配置-更新
// @Tags updatePointUser
// @Summary 积分用户
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/point/mainUser/update [post]

export var updatePointUser = function updatePointUser(data) {
  return service({
    url: '/activity/point/mainUser/update',
    method: 'post',
    data: data
  });
}; // 积分用户配置-删除
// @Tags deletePointUser
// @Summary 积分用户
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/point/mainUser/delete [post]

export var deletePointUser = function deletePointUser(data) {
  return service({
    url: '/activity/point/mainUser/delete',
    method: 'post',
    data: data
  });
}; // 积分记录-分页获取列表
// @Tags getPointRecordList
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/point/consume/getList [get]

export var getPointRecordList = function getPointRecordList(params) {
  return service({
    url: '/activity/point/consume/getList',
    method: 'get',
    params: params
  });
}; // 积分记录-下载
// @Tags downloadPointRecord
// @Summary 下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/point/consume/download [post]

export var downloadPointRecord = function downloadPointRecord(data) {
  return service({
    url: '/activity/point/consume/download',
    method: 'post',
    data: data
  });
}; // 积分用户配置-分页获取列表
// @Tags getPointUserSubList
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /activity/point/subUser/getList [get]

export var getPointUserSubList = function getPointUserSubList(params) {
  return service({
    url: '/activity/point/subUser/getList',
    method: 'get',
    params: params
  });
}; // 积分用户配置-添加
// @Tags createPointUserSub
// @Summary 积分用户
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "添加"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/point/subUser/create [post]

export var createPointUserSub = function createPointUserSub(data) {
  return service({
    url: '/activity/point/subUser/create',
    method: 'post',
    data: data
  });
}; // 积分用户配置-删除
// @Tags deletePointUserSub
// @Summary 积分用户
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /activity/point/subUser/delete [post]

export var deletePointUserSub = function deletePointUserSub(data) {
  return service({
    url: '/activity/point/subUser/delete',
    method: 'post',
    data: data
  });
};